(function () {

    'use strict';

    angular.module('Services').factory('ClientOfficeSchedulePickupsTable', ClientOfficeSchedulePickupsTable);
    ClientOfficeSchedulePickupsTable.$inject = [
        'ClientService',
        'TableLiteFactory',
        '$filter',
        'toastr',
        '$uibModal'
    ];
    function ClientOfficeSchedulePickupsTable(
        ClientService,
        TableLiteFactory,
        $filter,
        toastr,
        $uibModal
    ) {
        return function (opts) {
            const frequency = {
                MONDAY: false,
                TUESDAY: false,
                WEDNESDAY: false,
                THURSDAY: false,
                FRIDAY: false
            };
            function showAddSchedModal(sched) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'r-c-p-modal',
                    templateUrl: '/templates/pages/client/location/ScheduledPickupModal.html',
                    controller: 'ScheduledPickupModalController',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        schedule: function () {
                            return angular.copy(angular.extend(sched, { officeId: opts.id }))
                        }
                    }
                });

                modalInstance.result.then(function (data) {
                    tableActions.sendRequest({});
                }, function () {
                    tableActions.sendRequest({});
                });
            }
            let tableData = {
                tableName: 'OfficeSchedule',
                frequency: {
                    MONDAY: 'Mon',
                    TUESDAY: 'Tues',
                    WEDNESDAY: 'Wed',
                    THURSDAY: 'Thu',
                    FRIDAY: 'Fri',
                    SATURDAY: 'Sat',
                    SUNDAY: 'Sun'
                },
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'ADD PICKUP SCHEDULE',
                        onClick: function () {
                            showAddSchedModal({})
                        }
                    }]
                },
                config: {
                    noConfigureTable: true,
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    tableHeight: '230px',
                    tableMinHeight: '0px',
                },

                // todo: add implementation code here
                headers: [
                    {
                        label: 'Carrier',
                        viewName: 'carrierProfileName',
                    }, 
                    {
                        label: 'Service',
                        viewName: 'serviceProfileName',
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    }, 
                    {
                        label: 'Pick-up Time',
                        viewName: 'pickupTimeFormat',
                    }, 
                    {
                        label: 'Frequency',
                        viewName: 'frequencyFormat',
                    }, 
                    {
                        label: 'Cutoff',
                        viewName: 'cutoffFormatted',
                    }, 
                    {
                        label: 'First Mile Pickup Days',
                        viewName: 'firstMilePickupDays'
                    }, 
                    {
                        label: 'First Mile Cutoff',
                        viewName: 'firstMileCutoff'
                    }, 
                    {
                        label: 'First Mile Pickup Time',
                        viewName: 'firstMilePickupTime'
                    }, 
                    {
                        label: 'Last Mile Pickup Days',
                        viewName: 'lastMilePickupDays'
                    }, 
                    {
                        label: 'Last Mile Cutoff',
                        viewName: 'lastMileCutoff'
                    }, 
                    {
                        label: 'Last Mile Pickup Time',
                        viewName: 'lastMilePickupTime'
                    }, 
                    {
                        label: 'action',
                        viewName: 'action',
                    }
                ],
                rowOnClick: sched => showAddSchedModal(sched, sched.id),
                data: [],
                extractTable: function (form) {

                },
                resetFilters: () => {
                    tableActions.resetFilters();
                },
                onInit: function () {
                    tableActions.sendRequest({});
                }
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: ClientService.Location.getPickupSchedules,
                    callbackFormat: ['id', 'success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    paramId: opts.id,
                    defaultFilters: angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'id,asc'
                    })
                }
            );

            function buildTableData(data) {
                if (!data) return tableData;

                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {  
                    const frequencyValues = angular.copy(frequency);
                    item.carrierProfileName = angular.getObjVal(item, 'serviceProfile.carrierProfile.name') || 'N/A';
                    item.serviceProfileName = angular.getObjVal(item, 'serviceProfile.name') || 'N/A';
                    item.pickupTimeFormat = item.pickupTime;
                    item.pickupDays.forEach(fre => {
                        frequencyValues[fre] = true;
                    });
                    item.frequencyFormat = {
                        url: '/templates/pages/client/location/frequencyTableBody.html',
                        frequencyValues
                    };
                    item.cutoffFormatted = item.cutoff || 'N/A';
                    
                    // first mile
                    const firstMileFreqValues = angular.copy(frequency);
                    const firstMilePickupDays = angular.copy(item.firstMilePickupDays);
                    firstMilePickupDays.forEach(fre => {firstMileFreqValues[fre] = true;});
                    item.firstMilePickupDays = {
                        url: '/templates/pages/client/location/frequencyTableBody.html',
                        frequencyValues: firstMileFreqValues
                    };
                    item.firstMileCutoff = item.firstMileCutoff || 'N/A'
                    item.firstMilePickupTime = item.firstMilePickupTime || 'N/A';

                    // last mile
                    const lastMileFreqValues = angular.copy(frequency); 
                    const lastMilePickupDays = angular.copy(item.lastMilePickupDays);
                    lastMilePickupDays.forEach(fre => {lastMileFreqValues[fre] = true;});
                    item.lastMilePickupDays = {
                        url: '/templates/pages/client/location/frequencyTableBody.html',
                        frequencyValues: lastMileFreqValues
                    };
                    item.lastMileCutoff = item.firstMileCutoff || 'N/A';
                    item.lastMilePickupTime = item.firstMilePickupTime || 'N/A'; 

                    item.action = {
                        type: 'button',
                        buttons: [{
                            text: 'DELETE',
                            class: 'btn btn-danger btn-quirk',
                            action: function (row) {
                                ClientService.Location.deletePickupSchedule(row.id, () => tableActions.sendRequest({}),
                                    err => toastr.error('Unable to delete schedule', err.message));
                            }
                        }]
                    };
                    tableData.data.push(item);
                });
            }
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/clients/ClientOfficeSchedulePickupsTable.js